module.exports = __webpack_public_path__ + "img/cooperation9.168e62ed.png";